<div class="solicitare-container">
  <h1 class="solcitare-title">Adauga Departament</h1>
  <form
    class="solicitare-card__form"
   
    (submit)="submitForm()"
  >
    <div class="solicitare-nume">
      <mat-form-field appearance="fill">
        <mat-label>Nume</mat-label>
        <input type="text" matInput formControlName="name" />
      </mat-form-field>
      <mat-error
        *ngIf="!form.controls['name'].valid && form.controls['name'].touched"
      >
        Camp obligatoriu
      </mat-error>
    </div>

    <div class="solicitare-observatii">
      <mat-form-field appearance="fill">
        <mat-label>observatii</mat-label>
        <input type="text" matInput formControlName="observatii" />
      </mat-form-field>
      <mat-error
        *ngIf="
          !form.controls['observatii'].valid &&
          form.controls['observatii'].touched
        "
      >
        Camp obligatoriu
      </mat-error>
    </div>
    <div class="spinner"><mat-spinner *ngIf="isLoading"></mat-spinner></div>
    <div class="solicitare-action-btns">
      <button class="buttons" mat-flat-button (click)="closeDialog()">
        Close
      </button>
      <button class="buttons" mat-flat-button color="primary" type="submit">
        Save
      </button>
    </div>
  </form>
</div>
